import { useMutation, useQueryClient } from '@tanstack/react-query';

import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';

export const useLikeForumPost = (id: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (liked: boolean) => {
      return fetchJson(liked ? `/forum/posts/${id}/like` : `/forum/posts/${id}/unlike`, {
        method: 'POST',
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QueryKeys.forum.show.id(id) });
      queryClient.invalidateQueries({ queryKey: QueryKeys.forum.index.root });
    },
  });
};
